angular.module('rjmNg.directives').directive 'sortableUi', [
  '$timeout'
  ($timeout) ->
    restrict: 'A'
    scope:
      sortableOptions: '='
    controller: [
      '$scope'
      '$element'
      '$attrs'
      ($scope, $element, $attrs) ->
        $scope.render = () ->
          $element.sortable($scope.options())

        $scope.options = if $scope.sortableOptions then $scope.sortableOptions else {}
        $scope.render()
        ]
]
